// WARNING: This module assumes the environment will provide the jQuery UI
// Autocomplete plugin. See the .bindSearcher() JSDoc below for more details.

/* This is used different projects some of which
 * may not have access to goog.provide so we check
 * for it first
 */
if (typeof(goog) !== 'undefined' && typeof(goog.provide) !== 'undefined') {
  goog.provide('yext.categorysearcher');
}
yext.categorysearcher = {};

/**
 * Category Searcher
 *
 * @author MattJS (matt@yext.com)
 */
(function($) {
  var _categorysearcher = yext.categorysearcher;

  var
    categoryMap = {};
  var categorySearcherMap = {};
  var categoryUID = 1;
  var categorySearcherUID = 1;
  var categoryUIDString = 'categoryUID';
  var categorySearcherUIDString = 'categorySearcherUID';
  var defaultOptions = {
    'maxListSize': 10,
    'categorySearchUrl': '/s/locationssearch/_locationsearch/searchcategories',
    'supportsAccurateCount': false,
    'searchParameters': {},
  };
  var minimumCharactersToSearch = 3;
  var minimumCharactersToSearchByCountry = {
    'zh': 1, // China
    'ja': 1, // Japan
  };

  // PRIVATE FUNCTIONS
  /**
   * Get a category using the UID from the element data
   *
   * @param {!jQuery} The element that represents a category
   */
  var getCategory = function($element) {
    return categoryMap[$element.data(categoryUIDString)];
  };

  /**
   * Escape a string that you would like to build a regular expression with
   *
   * Special characters that must be escaped: \ ^ $ * + ? . ( ) | { } [ ]
   */
  var escapeRegExp = (function() {
    var re = /[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g;
    return function(str) {
      return str.replace(re, '\\$&');
    };
  })();

  /**
   * Return a dummy result to the searcher represented by and id
   * of -1. This allows for messages to be displayed that are
   * unselectable
   *
   * @param {string} msg The message for the dummy result
   * @return {!Array.<Object>} The dummy response
   */
  var dummyResult = function(msg) {
    return [{
      id: -1,
      message: msg,
    }];
  };

  /**
   * Checks for yext.msg so this can work in projects like resellers
   */
  var noCategoryMessage = function() {
    return typeof yext.msg === 'function'
        ? yext.msg('No matching category found')
        : 'No matching category found';
  };

  /**
   * Checks for yext.msg so this can work in projects like resellers
   */
  var keepTypingMessage = function() {
    return typeof yext.msg === 'function'
        ? yext.msg('Keep typing to see matching categories')
        : 'Keep typing to see matching categories';
  };

  /**
   * Bind the searcher
   *
   * Instantiate the jQuery UI autocomplete widget and customize the
   * extension points to fit our needs.
   *
   * This must be called with a context that provides the following properties/methods :
   * options.categorySearchUrl, addCategory(), additionalSearchParameters() (optional)
   *
   * $input must be from a jQuery that has the jQuery UI Autocomplete plugin
   * installed. Most Yext pages and JavaScript bundles already have this, but
   * if your JavaScript bundle doesn't already have it, you should
   *
   * require('jquery-ui/ui/widgets/autocomplete');
   *
   * and make sure $item comes from the jQuery that is updated by that require.
   *
   * (This module doesn't do the require itself because it's used via multiple
   * methods, not all of which support require.)
   *
   * @param {!jQuery} $input The searcher
   * @suppress {deprecated}
   */
  var bindSearcher = function($input) {
    var self = this;

    // Change the minimum characters to search based upon country
    var minChars = minimumCharactersToSearch;
    if (minimumCharactersToSearchByCountry[navigator['language']]) {
      minChars = minimumCharactersToSearchByCountry[navigator['language']];
    }

    var debounce;

    $input.autocomplete({
      source: function(request, response) {
        clearTimeout(debounce);
        if (request['term'].length >= minChars) {
          var params = {};
          if (typeof self.additionalSearchParameters === 'function') {
            params = self.additionalSearchParameters();
          }
          params['token'] = request['term'];
          if (self.countryCodes) {
            params['country'] = self.countryCodes;
          }

          debounce = setTimeout(function() {
            $.get(self.options['categorySearchUrl'], params, function(data) {
              if (data.length === 0) {
                response(dummyResult(noCategoryMessage()));
              } else {
                response(data);
              }
            });
          }, 200);
        } else {
          response(dummyResult(keepTypingMessage()));
        }
      },
      select: function(event, ui) {
        $input.val(ui.item['fullName']);
        self.addCategory(ui.item, $input);
        return false;
      },
    });

    var data = $input.data();
    // Support multiple versions of jQueryUI
    var autoComplete = data['autocomplete'] ? data['autocomplete'] : data['uiAutocomplete'];

    // Handle dummy result render & other customizations
    autoComplete['_renderMenu'] = function($ul, items) {
      var reString = '^(.*';
      // Should not be greedy unless searching for by leaf nodes only
      if (!self.options['searchParameters']['searchByLeafOnly']) {
        reString += '?';
      }
      reString += ')(' + escapeRegExp($.trim(this['term'])) +')(.*)$';

      var re = new RegExp(reString, 'gim');

      $ul.addClass('category-searcher-autocomplete');
      $ul.addClass('category-searcher-' + self.options.type);

      // Handles changing z-index of dialog that the searcher could possibly be in
      var dialog = $('.ui-dialog');
      if (dialog.length > 0) {
        var maxZIndex = Math.max(...dialog.toArray().map(d => $(d).css('z-index')), 1);
        $ul.css('z-index', maxZIndex + 1);
      }

      for (var i = 0; i < items.length; i++) {
        var item = items[i];
        if (item['id'] !== -1) {
          // Search term highlighting
          re.lastIndex = 0; // Reset the state of the regex
          var matches = re.exec(item['fullName']);
          if (matches) { // Multi term search a bit harder to highlight
            matches.shift(); // Remove the full match
            matches[1] = '<span>' + matches[1] + '</span>';
            item.highlighted = matches.join('');
          }
        }
        this._renderItem($ul, item);
      }
    };

    autoComplete._renderItem = function($ul, item) {
      var $li = $('<li>').appendTo($ul);
      if (item.id === -1) { // Dummy id should not be selectable
        $li.addClass('ui-state-disabled').html(item.message);
      } else {
        $li
          .data('item.autocomplete', item) // Put the item data where it should be
          .data('ui-autocomplete-item', item) // jQuery UI 1.9+ version of above
          .attr('data-category-id', item.id)
          .html('<a>' + item.highlighted + '</a>');
      }
      if (item['showCategory'] === false) {
        $li.addClass('hidden-category');
      }
      return $li;
    };
  };
  // END PRIVATE FUNCTIONS

  /**
   * Category model
   *
   * The model that represents the category
   *
   * @param {!Object} data Initialization data for the object
   */
  var Category = function(data) {
    this.id = data['id'];
    this.externalId = data['externalId'];
    this.name = data['name'];
    this.fullName = data['fullName'];
    this.showCategory = typeof data['showCategory'] === 'boolean' ? data['showCategory'] : true;
    this.isChainCategory = typeof data['isChainCategory'] === 'boolean' ? data['isChainCategory'] : false;
    this.indeterminate = typeof data['indeterminate'] === 'boolean' ? data['indeterminate'] : undefined;
  };

  /**
   * Get non-prototype properties off the category
   *
   * @return {!Object} Category properties
   */
  Category.prototype.ownProperties = function() {
    var properties = {};
    for (var prop in this) {
      if (this.hasOwnProperty(prop)) {
        properties[prop] = this[prop];
      }
    }
    return properties;
  };

  /**
   * View model that is paired with the Category model
   *
   * @param {Category} category Category model
   * @param {!jQuery} The category element represented by this view model
   */
  var CategoryView = function(category, $element) {
    if (!(category instanceof Category)) {
      throw new TypeError('Object provided must be of type Category');
    }

    this.$element = $element;

    this.model = category;
    this.UID = categoryUID++;
    this.checked = true;
    this.avaliableCountries = [];

    this.$element.data(categoryUIDString, this.UID);
    categoryMap[this.UID] = this;

    this.render();
  };

  /**
   * Render the category using values from the model
   */
  CategoryView.prototype.render = function() {
    if (this.model.indeterminate) {
      this.$element.find('.js-checked').prop({
        'indeterminate': true,
        'checked': false,
      });
    }

    this.$element.find('.js-category-name').html(this.model.fullName);
  };

  /**
   * Broadcast a message indicating that the category has been updated
   */
  CategoryView.prototype.updated = function() {
    $(this).trigger('updated');
  };

  /**
   * Destroy this category
   */
  CategoryView.prototype.destroy = function() {
    $(this).off();
    delete categoryMap[this.UID];
  };

  /**
  * Single category searcher
  *
  * This is a simple input for searching for one category vs making a category
  * list with CategorySearcher.
  *
  * @param {!jQuery} $element The container for the category searcher
  * @param {!Object} options Configurable options for the category searcher
  */
  var CategorySearcherSingle = function($element, options) {
    this.$element = $element;
    this.$input = $element.find('.js-category-input');

    this.options = $.extend({}, defaultOptions, options || {});
    this.category = undefined;

    this.UID = categorySearcherUID++;

    this.$element.data(categorySearcherUIDString, this.UID);
    categorySearcherMap[this.UID] = this;

    // Set these to listen for events. On and trigger not avaliable in
    // jQuery 1.4
    // TODO(mattjs) Upgrade admin2 and change these to custom events
    this.categorySelected = function() {};
    this.categoryCleared = function() {};

    // Store the instance so that events can be customized
    this.$element.data('categorysearcher', this);

    this.getCategory();
    this.bindCategoryChange();
    this.bindSearcher(this.$input);
  };

  /**
   * Get category from dom and load name if necessary
   */
  CategorySearcherSingle.prototype.getCategory = function() {
    var categoryId = this.$element.data('categoryid');
    if (categoryId) {
      this.category = new Category({
        'id': categoryId,
        'fullName': this.$input.val(),
      });

      if (!this.category.fullName) {
        this.loadCategory();
      }
    }
  };

  /**
   * Load additional details about the category from its id
   */
  CategorySearcherSingle.prototype.loadCategory = function() {
    var self = this;
    var params = $.extend({}, this.additionalSearchParameters(), {'categoryId': this.category.id});
    $.get(this.options['categorySearchUrl'], params, function(result) {
      if (result.length) {
        self.category.fullName = result[0]['fullName'];
        self.category.name = result[0]['name'];
        self.category.showCategory = result[0]['showCategory'];
        self.render();
      } else {
        self.clearCategory();
      }
    });
  };

  /**
   * If a category is selected, checks if it has been cleared by
   * comapring category names
   */
  CategorySearcherSingle.prototype.bindCategoryChange = function() {
    var self = this;
    this.$input.keyup(function() {
      if (typeof self.category !== 'undefined') {
        var fullName = self.$input.val().trim();
        if (fullName !== self.category.fullName) {
          self.category = undefined;
          self.$input.removeClass('hidden-category');
          self.categoryCleared();
        }
      }
    });
  };

  /**
   * Use the shared bindSearcher method
   */
  CategorySearcherSingle.prototype.bindSearcher = bindSearcher;

  /**
   * Triggered when a category is added
   * @param {!Object} data Category data
   */
  CategorySearcherSingle.prototype.addCategory = function(data) {
    this.category = new Category(data);
    this.render();
    this.categorySelected();
  };

  /**
   * Clear the current category
   */
  CategorySearcherSingle.prototype.clearCategory = function() {
    this.category = undefined;
    this.render();
    this.categoryCleared();
  };

  /**
   * @return {boolean}
   */
  CategorySearcherSingle.prototype.hasCategory = function() {
    return this.category instanceof Category;
  };

  /**
   * Get additional search parameters for the category search
   *
   * @return {!Object} Key/values to be used in search
   */
  CategorySearcherSingle.prototype.additionalSearchParameters = function() {
    return this.options['searchParameters'];
  };

  /**
   * Set the category
   *
   * @param {!Object} category Category details
   */
  CategorySearcherSingle.prototype.setCategory = function(category) {
    this.category = new Category(category);
    this.render();
    this.categorySelected();
  };

  /**
   * Render the category name
   */
  CategorySearcherSingle.prototype.render = function() {
    if (this.category instanceof Category) {
      this.$input.val(this.category.fullName);
      this.$input.toggleClass('hidden-category', this.category.showCategory === false);
    } else {
      this.$input.val('');
    }
  };

  /**
   * Prevent memory leaks when removing category searcher
   * @suppress {deprecated}
   */
  CategorySearcherSingle.prototype.destroy = function() {
    delete categorySearcherMap[this.UID];
    this.$input.autocomplete('destroy');
  };

  /**
   * Category Searcher class
   *
   * Allows categories to be searched and added to a list
   *
   * @param {!jQuery} $element The container for the category searcher and category list
   * @param {!Object} options Configurable options for the category searcher
   */
  var CategorySearcher = function($element, options) {
    this.$element = $element;
    this.$categories = $element.find('.js-categories-container');
    this.$categoryTemplate = $($element.find('.js-category-template').html());
    this.$searcherTemplate = $($element.find('.js-searcher-template').html());

    this.options = $.extend({}, defaultOptions, options || {});
    this.categories = [];
    this.storedValues = {};
    this.reordered = false;

    this.getCategories();
    this.storeValues();
    this.bindAddCategory();
    this.bindCategoryCheckboxes();
    this.bindDeleteCategory();
    this.bindReorderCategories();
  };

  /**
   * Extract details about the current categories from the DOM
   */
  CategorySearcher.prototype.getCategories = function() {
    var self = this;
    var newlineRe = /\n/g;

    this.clearCategories();
    this.categories = this.$categories.find('.js-category').map(function() {
      var $this = $(this);
      var category = new Category({
        'id': $this.data('id'),
        'fullName': $this.find('.js-category-name').text().trim().replace(newlineRe, ''),
        'showCategory': $this.data('showCategory'),
        'isChainCategory': $this.data('isChainCategory'),
        'indeterminate': $this.find('.js-checked').data('indeterminate'),
      });
      var categoryView = new CategoryView(category, $this);
      $(categoryView).on('updated', function() {
        self.message('updated');
      });
      return categoryView;
    }).get();
    this.toggleAddCategory();
  };

  /**
   * Store the searcher values so they can be restored with the reset method
   */
  CategorySearcher.prototype.storeValues = function() {
    this.storedValues = {};
    this.storedValues.categories = [];
    for (var i = 0; i < this.categories.length; i++) {
      var category = this.categories[i];
      this.storedValues.categories.push(category.model.ownProperties());
    }
  };

  /**
   * Reset the searcher to the state stored in storedValues
   */
  CategorySearcher.prototype.reset = function() {
    this.reconcile(this.storedValues);
    this.toggleAddCategory();
  };

  /**
   * Rebuild the searcher
   *
   * @param {!Object} field Details about the state which to restore the searcher
   */
  CategorySearcher.prototype.reconcile = function(field) {
    this.clearCategories();
    this.$categories.empty();
    for (var i = 0; i < field.categories.length; i++) {
      var view = this.addCategory(field.categories[i]);
    }
    this.render();
  };

  /**
   * Cleanup to prevent memory leaks
   */
  CategorySearcher.prototype.clearCategories = function() {
    for (var i = 0; i < this.categories.length; i++) {
      this.categories[i].destroy();
    }
    this.categories = [];
  };

  /**
   * @return {boolean}
   */
  CategorySearcher.prototype.hasCategories = function() {
    return this.categories.length !== 0;
  };

  /**
   * Render the category searcher
   */
  CategorySearcher.prototype.render = function() {
    this.toggleReorder();
  };

  /**
   * Bind the add category link
   */
  CategorySearcher.prototype.bindAddCategory = function() {
    var self = this;

    this.$element.find('.js-add-category').click(function() {
      var $element = self.$searcherTemplate.clone();

      self.onAddCategory($element);
    });
  };

  /**
   * Action when a Category is added to the categorySearcher
   * @param  {!jQuery} $element Category Element
   */
  CategorySearcher.prototype.onAddCategory = function($element) {
    var $input = $element.find('.js-category-input');

    this.bindSearcher($input);
    this.renderSearcher($element);
    this.$categories.append($element);
    $input.focus();
    this.toggleReorder();
    this.toggleAddCategory();
  };

  /**
   * Use the shared bindSearcher method
   *
   * @param {!jQuery} $element The searcher
   */
  CategorySearcher.prototype.bindSearcher = bindSearcher;

  /**
   * Extension point. Can be overridden by child class
   *
   * @param {!jQuery} $element The searcher
   */
  CategorySearcher.prototype.renderSearcher = function($element) {};

  /**
   * Add a new category
   *
   * Used during editing and when restoring the categories after a save or from
   * a set of stored values
   *
   * @param {!Object} data Category data
   * @param {!jQuery} $input Optional input that was used for searching
   * @return {CategoryView} The view model representing the category
   * @suppress {deprecated}
   */
  CategorySearcher.prototype.addCategory = function(data, $input) {
    var category = new Category(data);
    var categoryView = new CategoryView(
      category,
      this.$categoryTemplate.clone(),
    );
    var self = this;

    this.categories.push(categoryView);
    this.renderCategory(categoryView);

    if ($input) {
      $input.autocomplete('destroy');
      $input.closest('.js-searcher').replaceWith(categoryView.$element);
    } else {
      this.$categories.append(categoryView.$element);
    }

    this.message('updated');
    this.toggleAddCategory();

    $(categoryView).on('updated', function() {
      self.message('updated');
    });

    return categoryView;
  };

  /**
   * Extension point
   *
   * @param {CategoryView} Category view model
   */
  CategorySearcher.prototype.renderCategory = function(categoryView) {};

  /**
   * Use event delegation to handle checkboxes with less memory
   */
  CategorySearcher.prototype.bindCategoryCheckboxes = function() {
    this.$categories.on('click', '.js-checked', function() {
      var $check = $(this);
      var $category = $check.closest('.js-category');

      var category = getCategory($category);

      if (category instanceof CategoryView) {
        if ($check.prop('checked') === true) {
          category.checked = true;
          category.model.indeterminate = false;
        } else {
          category.checked = false;
        }
        category.updated();
      }
    });
  };

  /**
   * Use event delgation to bind the category delete
   * @suppress {deprecated}
   */
  CategorySearcher.prototype.bindDeleteCategory = function() {
    var self = this;

    this.$categories.on('click', '.js-delete-category', function() {
      var $category = $(this).closest('.js-category');
      var category = getCategory($category);

      if (category instanceof CategoryView) {
        category.destroy();
        var index = self.categories.indexOf(category);
        self.categories.splice(index, 1);
        self.message('updated');
      } else {
        $category.find('.js-category-input').autocomplete('destroy');
      }
      $category.remove();
      self.toggleReorder();
      self.toggleAddCategory();
    });
  };

  /**
   * Use jQuery sortable to allow categories to be reordered.
   */
  CategorySearcher.prototype.bindReorderCategories = function() {
    var self = this;
    this.$categories.sortable({
      'handle': '.js-reorder',
      'axis': 'y',
      'stop': function(e, ui) {
        self.listReordered();
        // Note (dwen): Firefox sets top/left to 0 on stop, which causes the
        // image to be misaligned the next time it gets dragged. Explicitly
        // set top/left to auto to fix this.
        ui.item
          .css('top', 'auto')
          .css('left', 'auto');
      },
      'containment': this.$categories,
      'tolerance': 'pointer',
    });
  };

  /**
   * Get an array of category ids that are currently selected
   *
   * @param {!Array.<number|string>} List of category ids
   */
  CategorySearcher.prototype.getCategoryIds = function() {
    return this.categories.map(function(category) {
      return category.model.id;
    });
  };

  /**
   * Get additonal search parameters for the category search
   *
   * @return {!Object} Key/values to be used in search
   */
  CategorySearcher.prototype.additionalSearchParameters = function() {
    return $.extend({}, this.options['searchParameters'], {
      'selectedCategoryIds': this.getCategoryIds().join('|||'),
    });
  };

  /**
   * Returns array of checked shown categories
   *
   * @return {!Array.<CategoryView>} List of checked shown categories
   */
  CategorySearcher.prototype.getCheckedShownCategories = function() {
    return this.categories.filter(function(category) {
      return category.checked && category.model.showCategory && !category.model.isChainCategory;
    });
  };

  /**
   * Returns number of hidden categories
   *
   * @return {number} Number of hidden categories
   */
  CategorySearcher.prototype.getNumHiddenCategories = function() {
    var hiddenCategories = 0;
    for (var i = 0; i < this.categories.length; i++) {
      var category = this.categories[i].model;
      if (!category.showCategory || category.isChainCategory) {
        hiddenCategories++;
      }
    }
    return hiddenCategories;
  };

  /**
   * Called when the list has be reordered to keep the array bound to the view.
   * A message will be published to show the searcher was updated
   */
  CategorySearcher.prototype.listReordered = function() {
    this.categories = this.$categories.find('.js-category').map(function() {
      return getCategory($(this));
    }).get();
    this.reordered = true;
    this.message('updated');
  };

  /**
   * Toggle the reorder handles if there is only one category
   */
  CategorySearcher.prototype.toggleReorder = function() {
    var count = this.$categories.find('.js-category').length;
    this.$categories.find('.js-reorder').toggle(count > 1);
  };

  /**
   * Toggle the link to add another category
   */
  CategorySearcher.prototype.toggleAddCategory = function() {
    var count = this.$categories.find('.js-category').length;
    var maxSize = this.options['maxListSize'] + this.getNumHiddenCategories();

    if (this.options['supportsAccurateCount']) {
      const $categoryGroupContainer = this.$element.closest('.js-category-group-edit');
      const $primaryCategoryGroup = $categoryGroupContainer.find('.js-primary-category-group');

      if ($primaryCategoryGroup.find('.js-standalone-category-name').text()) {
        count += 1;
      }
    }

    this.$element.find('.js-add-category').toggle(count < maxSize);
  };

  /**
   * Broadcast a message that can be captured
   *
   * @param {string} message The message to be published
   */
  CategorySearcher.prototype.message = function(message) {
    $(this).trigger(message);
  };

  /**
   * @return {!Object} Raw field data
   */
  CategorySearcher.prototype.getData = function() {
    var field = {
      numElided: this.numElided,
      reordered: this.reordered,
      categories: [],
    };

    this.categories.forEach(function(category) {
      if (category.checked) {
        field.categories.push(category.model);
      }
    });

    return field;
  };

  /**
   * Create a new multiple category searcher
   *
   * @param {!jQuery} $element The container for the category searcher and category list
   * @param {!Object} options Configurable options for the category searcher
   * @return {CategorySearcher} Searcher instance
   */
  _categorysearcher.create = function($element, options) {
    return new CategorySearcher($element, options);
  };

  /**
   * Create a new single category searcher
   *
   * @param {!jQuery} $element The container for the category searcher
   * @param {!Object} options Configurable options for the category searcher
   * @return {CategorySearcherSingle} Searcher instance
   */
  _categorysearcher.createSingle = function($element, options) {
    return new CategorySearcherSingle($element, options);
  };

  /**
   * Get a category searcher using the UID from the element data
   *
   * @param {!jQuery} The element that represents a category searcher
   */
  _categorysearcher.get = function($element) {
    return categorySearcherMap[$element.data(categorySearcherUIDString)];
  };
  // Export this baby
  _categorysearcher.Model = CategorySearcher;
})(jQuery);
